import Mask from "@/components/mask";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { createRoot } from "react-dom/client";

export default function WeChatMask({
	visible,
	onClose,
	text,
}: {
	visible: boolean;
	onClose: () => void;
	text?: string;
}) {
	const { t } = useTranslation("common");

	return (
		<Mask visible={visible} onMaskClick={onClose} style={{ "--z-index": "9999" }}>
			<div className="flex justify-end px-6">
				<Image
					src="https://web-cdn.rockflow.tech/rockflow-website/open-in-browser.png"
					alt="open in browser"
					height={51}
					width={39}
					style={{
						maxWidth: "100%",
						height: "auto",
					}}
				/>
			</div>
			<div className="px-2 text-center text-white">{text || t("weixin-open")}</div>
		</Mask>
	);
}

/**
 *
 */
WeChatMask.open = (text?: string) => {
	const container = document.createElement("div");
	document.body.appendChild(container);
	const root = createRoot(container);

	const render = () => {
		root.render(<WeChatMask visible onClose={close} text={text} />);
	};

	const close = () => {
		root.unmount();
		if (container.parentNode) {
			document.body.removeChild(container);
		}
	};

	render();

	return { close };
};
